const customMediaQuery = (minWidth: number) =>
  `@media (min-width: ${minWidth}px)`;

export const media = {
  one: customMediaQuery(420),
  duo: customMediaQuery(540),
  three: customMediaQuery(600),
  min600: customMediaQuery(600),
  min670: customMediaQuery(670),

  min360: customMediaQuery(360),
  min414: customMediaQuery(414),
  min480: customMediaQuery(480),
  min540: customMediaQuery(540),
  min880: customMediaQuery(880),
  small: customMediaQuery(768),
  tablet: customMediaQuery(990),
  min1000: customMediaQuery(1000),
  desktop: customMediaQuery(1200),
};

const colors = {
  R100: "#ff4f40",
  R200: "#c23735",

  I50: "#bcbaff",
  I75: "#908bff",
  I100: "#635dff",
  I200: "#564ed1",

  G25: "#def7f1",
  G50: "#88e3cd",
  G75: "#31cea8",
  G100: "#13a688",
  G200: "#0d8975",
  G400: "#31cea8",

  N0: "#fff",
  N5: "#fafbfc",
  N10: "#f6f7fa",
  N20: "#f1f3f7",
  N30: "#e9ecf3",
  N40: "#dadfe8",
  N50: "#ccd2dc",
  N60: "#bdc4cf",
  N70: "#b1b7c2",
  N80: "#a5abb6",
  N90: "#999fa9",
  N100: "#8c929c",
  N200: "#80868f",
  N300: "#737981",
  N400: "#676c74",
  N500: "#5a5f66",
  N600: "#4e535a",
  N700: "#42464d",
  N800: "#3a3e44",
  N900: "#1e212a",
  BLACK: "#000000",

  B500: "#1071f2",
  B800: "#00407d",

  R500: "#d03c38",
  R800: "#5f0f24",

  Y500: "#b8952e",
  Y800: "#522c09",

  G500: "#13a688",
  G800: "#004e4e",

  lightAluminium: "#eaecee",
  darkAluminium: "#2a2e35",
  Y100: "#ebca40",
  O200: "#ff7f38",
  P50: "#ffaff0",
  P75: "#ff79e7",
  P100: "#ff44dd",
  A100: "#65d1ef",
  A200: "#3ec6eb",

  lightPink: "#e8bee0",
  blue: "#3885ff",
  emerald: "#1bc99f",
  lightEmerald: "#82e0ca",

  focus: "rgba(16, 113, 242, 0.24)",
  error: "#e69ad8",
};

const fonts = {
  fontPrimary: `"Inter", sans-serif`,
  fontSecondary: `"Space Grotesk", sans-serif`,
  fontMono: `"Roboto Mono", monospace`,
};

export const theme = {
  media,
  colors,
  fonts,
};
